import React, { useState, useEffect, createContext, Suspense, lazy } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { getMoi } from './services/api';
import { useToast } from './components/Toast';
import ErrorBoundary from './components/ErrorBoundary';
import Navbar from './components/Navbar';
import Sidebar from './components/Sidebar';

// Lazy loading des pages pour réduire le bundle initial
const Connexion = lazy(() => import('./pages/Connexion'));
const Dashboard = lazy(() => import('./pages/Dashboard'));
const ProjetDetail = lazy(() => import('./pages/ProjetDetail'));
const Utilisateurs = lazy(() => import('./pages/Utilisateurs'));
const ContratsExternes = lazy(() => import('./pages/ContratsExternes'));
const PortailPartenaire = lazy(() => import('./pages/PortailPartenaire'));
const SiscoPanel = lazy(() => import('./pages/SiscoPanel'));

export const ToastContext = createContext(null);

const mainStyle = {
  marginLeft: 260, marginTop: 56, minHeight: 'calc(100vh - 56px)',
  backgroundColor: '#0f172a', padding: '0'
};

const loaderStyle = {
  display: 'flex', alignItems: 'center', justifyContent: 'center',
  minHeight: '60vh', color: '#64748b', fontSize: 14
};

const PageLoader = () => <div style={loaderStyle}>Chargement...</div>;

export default function App() {
  const [user, setUser] = useState(null);
  const [chargement, setChargement] = useState(true);
  const toast = useToast();

  useEffect(() => {
    const token = localStorage.getItem('sigepro_token');
    if (token) {
      getMoi()
        .then(res => setUser(res.data.user))
        .catch(() => localStorage.removeItem('sigepro_token'))
        .finally(() => setChargement(false));
    } else {
      setChargement(false);
    }
  }, []);

  if (chargement) return null;

  return (
    <ErrorBoundary>
      <ToastContext.Provider value={toast}>
        <BrowserRouter>
          <toast.ToastContainer />
          {user ? (
            <>
              <Sidebar user={user} />
              <Navbar user={user} onDeconnexion={() => setUser(null)} />
              <main style={mainStyle}>
                <Suspense fallback={<PageLoader />}>
                  <Routes>
                    <Route path="/dashboard" element={<Dashboard />} />
                    <Route path="/projet/:id" element={<ProjetDetail />} />
                    <Route path="/utilisateurs" element={<Utilisateurs />} />
                    <Route path="/contrats" element={<ContratsExternes />} />
                    <Route path="/sisco" element={<SiscoPanel />} />
                    <Route path="/portail" element={<PortailPartenaire />} />
                    <Route path="*" element={<Navigate to="/dashboard" />} />
                  </Routes>
                </Suspense>
              </main>
            </>
          ) : (
            <Suspense fallback={<PageLoader />}>
              <Routes>
                <Route path="/connexion" element={<Connexion onAuth={setUser} />} />
                <Route path="/portail" element={<PortailPartenaire />} />
                <Route path="*" element={<Navigate to="/connexion" />} />
              </Routes>
            </Suspense>
          )}
        </BrowserRouter>
      </ToastContext.Provider>
    </ErrorBoundary>
  );
}
